import Phaser from 'phaser';

class PreloaderScene extends Phaser.Scene {
  constructor() {
    // The `key` is a unique identifier for this scene, used to reference it in the game.
    super({ key: 'PreloaderScene' });
  }

  preload() {
    console.log('PreloaderScene: preload');
    // Fix paths by removing leading slashes for better compatibility in production builds
    this.load.tilemapTiledJSON('theme_02', 'assets/theme2/maps/theme2.tmj');

    // Fix the path to the tileset image
    this.load.image('tileset2', 'assets/theme2/tiles/theme2.png');

    // Load the theme3 tilemap and tileset
    this.load.tilemapTiledJSON('theme_03', 'assets/theme3/maps/theme3.tmj');
    this.load.image('tileset3', 'assets/theme3/tiles/theme3.png');

    // Player sprite atlas path is already correct, but ensure consistency
    this.load.atlas(
      'player',
      'assets/heros/player.png',
      'assets/heros/player.json'
    );

    // Load the coins
    this.load.spritesheet('coin', '/assets/ui/CoinSheet.png', {
      frameWidth: 16,
      frameHeight: 16,
    });

   
    this.load.on('filecomplete-tilemapJSON-theme_03', () => {
      console.log('✅ theme_03 tilemap loaded successfully!');
    });

    this.load.on('filecomplete-image-tileset3', () => {
      console.log('✅ tileset3 image loaded successfully!');
    });

    this.load.spritesheet('badges', 'assets/ui/badge6.png', {
      frameWidth: 16,
      frameHeight: 16,
    });
    

  }

  create() {
    console.log('PreloaderScene: create');
    // Start the main game scene after preloading. The parameter is the key of the scene to start.
    this.scene.start('PhaserGameScene');
  }
}

export default PreloaderScene;